import { TextField } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import type { InputProps } from "../answers";

import { fieldSx } from "./optionSx";

const inputTypes = { plain: "text", email: "email", phone: "tel", url: "url", orgNumber: "text" };

export const TextInput: React.FC<InputProps<"text">> = ({ question, answer, onChange, error }) => {
    const { formatMessage } = useIntl();
    const format = question.format ?? "plain";
    const value = typeof answer?.value === "string" ? answer.value : "";
    const placeholder = {
        plain: formatMessage({ defaultMessage: "Your answer" }),
        email: formatMessage({ defaultMessage: "Email address" }),
        phone: formatMessage({ defaultMessage: "Phone number" }),
        url: formatMessage({ defaultMessage: "Website" }),
        orgNumber: formatMessage({ defaultMessage: "Organisation number" }),
    }[format];

    const long = format === "plain" && (!question.maxChars || question.maxChars > 200);

    return (
        <TextField
            fullWidth
            size="small"
            type={inputTypes[format]}
            multiline={long}
            minRows={long ? 2 : undefined}
            placeholder={placeholder}
            value={value}
            error={error}
            onChange={(event) => onChange({ ...answer, value: event.target.value })}
            helperText={question.maxChars ? `${value.length} / ${question.maxChars}` : undefined}
            slotProps={{ formHelperText: { sx: { textAlign: "right", mx: 0 } } }}
            sx={fieldSx}
        />
    );
};
